// the vanity hosts fronted by Cloudflare; a raw Spaces URL has no transform rule
const cdnHosts = new Set(['assets.corso.com', 'assets.stg.corso.com']);
/**
 * Opts an asset into the Cloudflare `Transform Images At Edge` rule, which
 * serves a resized, format-negotiated image and drops quality further for
 * clients asking for `Save-Data`.
 *
 * Safe to hand any src: the rule ignores what it does not match (a PDF, a path
 * outside customer media), and its `onerror=redirect` serves the original if a
 * transform fails. Only the host is checked here, so that a product image on a
 * platform CDN keeps its own cache key.
 *
 * Not for download links or content-type probes — those want the real bytes.
 */
export function optimizedImageSrc(src) {
    if (!src.startsWith('https://'))
        return src;
    const url = new URL(src);
    if (!cdnHosts.has(url.hostname))
        return src;
    url.searchParams.set('optimize', 'true');
    return url.toString();
}
//# sourceMappingURL=optimizedImageSrc.js.map